import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { gsap } from 'gsap';
import { ResponsiveService } from 'src/app/services/responsive.service';
import Player from '@vimeo/player';
import { RouterLink } from '@angular/router';
import { NewsletterSubscribeComponent } from '../newsletter-subscribe/newsletter-subscribe.component';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-about-video',
    templateUrl: './about-video.component.html',
    styleUrls: ['./about-video.component.css'],
    imports: [RouterLink, NewsletterSubscribeComponent, NgStyle]
})
export class AboutVideoComponent implements AfterViewInit {
  @ViewChild('playerAboutContainer') playerContainer: ElementRef;
  videoPlayer: Player;
  @ViewChild('AboutVideoMobile') mobileAboutVideoContainer: ElementRef;
  PlayHoverAnim;
  constructor(protected responsiveService: ResponsiveService) { }

  ngAfterViewInit(): void {
    let options;
    const _height = document.getElementById('SoulCastAboutVideo')?.clientHeight;
    const _width = document.getElementById('SoulCastAboutVideo')?.clientWidth;
    if (_height! > _width!) {
      options = {
        id: 766973548,
        height: _height,
        loop: true,
        background: true,
        controls: false
      };
    }
    else {
      options = {
        id: 766973548,
        width: _width,
        loop: true,
        background: true,
        controls: false
      };
    }
    
    if(this.mobileAboutVideoContainer != undefined)
      this.responsiveService.initAboutVideoResizeObserver(this.mobileAboutVideoContainer.nativeElement);

    if (this.playerContainer != undefined)
      this.videoPlayer = new Player(this.playerContainer.nativeElement, options);
    // IntersectionObserver
    const setupIntersectionObserver = function (target) {
      target.videoPlayer.pause();
      const optionsIntersectionObserver = { threshold: 0.1 }
      const callback = function (entries) {
        if (entries[0].isIntersecting) {
          target.videoPlayer.play();
        } else {
          target.videoPlayer.pause();
        }
      }
      const observer = new IntersectionObserver(callback, optionsIntersectionObserver);
      observer.observe(target.videoPlayer.element);
    };
    if (this.videoPlayer != undefined)
      this.videoPlayer.ready().then(() => setupIntersectionObserver(this));
  }

  OnPlayOver() {
    if (this.PlayHoverAnim)
      this.PlayHoverAnim.kill()
    this.PlayHoverAnim = gsap.timeline().fromTo('.RectF', 0.4, { autoAlpha: 0 }, { autoAlpha: 1 });
  }

  OnPlayLeave() {
    if (this.PlayHoverAnim) {
      this.PlayHoverAnim.duration(2)
      this.PlayHoverAnim.reverse();
    }
  }

}
